import {StyleSheet} from 'react-native';

import {Colors} from '../../constants/Colors';
import {styles as base} from '../ScheduledOrderReview/styles';

/**
 * PAG-01 — a tela do PEDIDO A PAGAR usa a folha da revisão programada.
 *
 * As duas telas mostram a mesma coisa — um carrinho montado pelo vendedor, com
 * o que o estoque ajustou — e precisam parecer a mesma coisa para o cliente,
 * que vai encontrar as duas no mesmo menu. Uma folha própria com valores
 * copiados divergiria na primeira mudança de espaçamento feita só de um lado, e
 * o cliente veria duas telas quase iguais.
 *
 * O que muda de verdade é a FAIXA DE PRAZO, que só existe aqui: o pedido
 * programado tem janela de três dias e o à vista morre às 23:59 de hoje. Ela é
 * a única informação que a tela precisa gritar.
 */
const extras = StyleSheet.create({
  prazo: {
    marginTop: 12,
    borderRadius: 8,
    padding: 12,
    backgroundColor: '#FFF4E5',
    borderWidth: 1,
    borderColor: '#F0B429',
  },
  prazoTitulo: {
    fontSize: 14,
    fontWeight: '700',
    color: '#8A5B00',
  },
  prazoTexto: {
    fontSize: 13,
    color: '#8A5B00',
    marginTop: 4,
  },
  prazoEncerrado: {
    backgroundColor: '#FDECEC',
    borderColor: Colors.RedPallete.red,
  },
  prazoTituloEncerrado: {
    color: Colors.RedPallete.red,
  },
  prazoTextoEncerrado: {
    color: Colors.RedPallete.red,
  },
  // CTA do bloco `blocoInviavel` (herdado de ScheduledOrderReview) — só existe
  // aqui, porque só o à vista tem essa saída oferecida diretamente no card. O
  // bloqueio é TOTAL (RN-23 item 3): sem um caminho pra regularizar, o
  // cliente lia o aviso e não tinha o que fazer além de sair da tela.
  blocoInviavelBotao: {
    marginTop: 10,
    alignSelf: 'flex-start',
    borderRadius: 6,
    paddingVertical: 8,
    paddingHorizontal: 14,
    backgroundColor: Colors.RedPallete.red,
  },
  blocoInviavelBotaoTexto: {
    fontSize: 13,
    fontWeight: '700',
    color: '#FFFFFF',
  },
});

export const styles = {...base, ...extras};
